import { render, staticRenderFns } from "./NameSystemMemoView.vue?vue&type=template&id=a636ad30&scoped=true&"
import script from "./NameSystemMemoView.vue?vue&type=script&lang=js&"
export * from "./NameSystemMemoView.vue?vue&type=script&lang=js&"
import style0 from "./NameSystemMemoView.vue?vue&type=style&index=0&id=a636ad30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a636ad30",
  null
  
)

export default component.exports